export const SET_MESSAGES = 'SET_MESSAGES';
export const RESET_MESSAGES_STATE = 'RESET_MESSAGES_STATE';
